module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histogram-container"
  }, [_c('div', {
    staticClass: "histogram-head"
  }, [(_vm.axisTitle.y && _vm.dataset.length) ? _c('div', {
    staticClass: "histogram-axisy-title"
  }, [_vm._v(_vm._s("(" + _vm.axisTitle.y + ")"))]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "histogramContent",
    staticClass: "histogram-content"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-127ea028!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/histogram-v/index.vue
// module id = 226
// module chunks = 0